import moment from "moment";
import { IColumnsGrouping } from "../../../components/table-grouping/TableGrouping";
import { TYPE } from "../../../constants/moduleConsts";

export const columnBaoHiemXaHoi: IColumnsGrouping[] = [
  {
    name: "STT",
    field: "stt",
    render: (row, index, stt) => <span>{stt}</span>,
  },
  {
    name: "Họ và tên",
    field: "fullName",
    headerStyle: {
      minWidth: "150px"
    },
    cellStyle: {
      textAlign: "left"
    },
  },
  {
    name: "Năm sinh",
    field: "birthDate",
    type: TYPE.DATE
  },
  {
    name: "Khoa/Phòng hiện đang công tác",
    field: "phongBanText",
    headerStyle: {
      minWidth: "150px"
    },
  },
  {
    name: "Số sổ Bảo hiểm xã hội",
    field: "soBHXH",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Số thẻ BHYT",
    field: "soBHYT",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Quá trình đóng bảo hiểm",
    field: "",
    child: [
      {
        name: "Tên chức danh nghề nghiệp",
        field: "chucDanhText",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Tên chức vụ",
        field: "chucVuText",
        headerStyle: {
          minWidth: "120px"
        },
      },
      {
        name: "Hệ số lương",
        field: "heSoLuong",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "PCCV",
        field: "phuCapCV",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "PC TNVK",
        field: "phuCapTNVK",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Ngày đóng hưởng lương",
        field: "ngayDongBH",
        headerStyle: {
          minWidth: "100px"
        },
        type: TYPE.DATE
      },
    ]
  },
  {
    name: "Ghi chú",
    field: "ghiChu",
    headerStyle: {
      minWidth: "100px"
    }
  }
];

export const columnKhenThuongKyLuat: IColumnsGrouping[] = [
  {
    name: "STT",
    field: "stt",
    render: (row, index, stt) => <span>{stt}</span>,
  },
  {
    name: "Họ và tên",
    field: "fullName",
    headerStyle: {
      minWidth: "150px"
    },
    cellStyle: {
      textAlign: "left"
    },
  },
  {
    name: "Năm sinh",
    field: "birthDate",
    type: TYPE.DATE
  },
  {
    name: "Khoa/Phòng hiện đang công tác",
    field: "phongBanText",
    headerStyle: {
      minWidth: "150px"
    },
  },
  {
    name: "Trình độ chuyên môn",
    field: "trinhDoChuyenMon",
    headerStyle: {
      minWidth: "100px"
    },
  },
  {
    name: "Khen thưởng",
    field: "",
    child: [
      {
        name: "Danh hiệu thi đua/Hình thức khen thưởng",
        field: "danhHieuThiDua",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Năm đạt danh hiệu",
        field: "namDatDanhHieu",
        headerStyle: {
          minWidth: "120px"
        },
      },
      {
        name: "Số, ngày tháng năm của Quyết định khen thưởng",
        field: "heSoLuong",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) => (
          <span>
            {row?.soQDKhenThuong || ""}
            {row?.ngayQDKhenThuong ? ` - ${moment(row.ngayQDKhenThuong).format("DD/MM/YYYY")}` : ""}
          </span>
        )
      }
    ]
  },
  {
    name: "Kỷ luật",
    field: "",
    child: [
      {
        name: "Hình thức kỷ luật",
        field: "hinhThucKyLuat",
        headerStyle: {
          minWidth: "100px"
        },
      },
      {
        name: "Lý do kỷ luật",
        field: "lyDoKyLuat",
        headerStyle: {
          minWidth: "120px"
        },
      },
      {
        name: "Năm kỷ luật",
        field: "namKyLuat",
        headerStyle: {
          minWidth: "120px"
        },
      },
      {
        name: "Số, ngày tháng năm của Quyết định kỷ luật",
        field: "heSoLuong",
        headerStyle: {
          minWidth: "100px"
        },
        render: (row: any) => (
          <span>
            {row?.soQDKyLuat || ""}
            {row?.ngayQDKyLuat ? ` - ${moment(row.ngayQDKyLuat).format("DD/MM/YYYY")}` : ""}
          </span>
        )
      }
    ]
  },
  {
    name: "Ghi chú",
    field: "ghiChu",
    headerStyle: {
      minWidth: "100px"
    }
  }
];